<template>
  <div class="layout-center-wrap">
    <section class="top_head">
      <div class="page-tit__wrap">
        <h1 class="page-tit__sub">취약점 조치</h1>
        <p class="page-tit">
          {{ pageTitle }}
        </p>
      </div>

      <div v-if="hasPatchUpdatable" class="write-edit">
        <div class="write-edit__wrap end">
          <div v-if="!edit">
            <span class="write-edit__txt">조회 모드</span>
            <button
              type="button"
              class="btn btn--green"
              @click="changeMod(true)"
            >
              편집
            </button>
          </div>
          <div v-if="edit">
            <span class="write-edit__txt"
              >편집 모드 <span class="write-edit__editable">수정 가능</span>
            </span>
            <span class="write-edit__btn-area">
              <button
                type="button"
                class="btn btn--green write-edit__btn"
                @click="changeMod(false)"
              >
                조회
              </button>
              <button
                type="button"
                class="btn btn--darker_blue write-edit__btn"
                @click="updatePatch()"
              >
                저장
              </button>
            </span>
          </div>
        </div>
      </div>
    </section>
    <!-- <Tabs :tabs="['패치 내용 작성']" v-model="selectedTab" role="tablist" /> -->
    <!-- 탭 내용 -->
    <component
      v-for="(tab, index) in tabComponents"
      :key="componentKey + index"
      :is="tab"
      v-show="selectedTab === index"
      ref="childRef"
      v-model="totalInfo"
      serviceType="patch"
      :userInfo="userInfo"
      :patchRequestList="patchRequestList"
      :tmpDeliveryStatusCodes="deliveryStatusCodes"
      @update:deliveryStatusCodes="handleDeliveryStatusCodes"
      :patchGuidesCodes="patchGuidesCodes"
      :edit="edit"
      :detailMod="hasPatchUpdatable"
      @changeTab="changeTab"
    />
    <div class="btn__wrap type-bottom-board" v-if="!hasPatchUpdatable">
      <button type="button" class="btn btn--l btn--blue" @click="addPatch()">
        접수
      </button>
    </div>
    <StatusReasonModal
      v-if="isModal"
      :isModal="isModal"
      @set="applySelectionReason"
      @close="closeReasonModal"
    />
  </div>
</template>
<script>
import dc from "@/component/DataChk.js";
import gt from "@/component/GetTokenValue.js";
import Tabs from "@/component/Tabs.vue";
import VulEval from "@/views/eval/CvssEval.vue";
import Submission from "@/views/patch/Submission.vue";
import editor from "@/editor/Editor.js";
import pactchHandler from "./PatchHandler.js";
import StatusReasonModal from "./modal/StatusReasonModal.vue";
import { computed, inject, onMounted, ref, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { deleteAllIndexedDBs } from "@/views/tempSave/TempSave.js";

export default {
  components: { VulEval, Tabs, Submission, StatusReasonModal },
  setup() {
    const lodash = inject("lodash");
    const dayjs = inject("dayjs");
    const axios = inject("axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // data 정의
    const userInfo = ref(gt.getMakrInfo());
    const isModal = ref(false);
    const componentKey = ref(0);
    const edit = ref(!route.query.id);
    const detailMod = ref(false);
    const pageTitle = ref("취약점 패치 접수");
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");
    const selectedTab = ref(0); // 탭 인덱스 관리
    const patchRegInfo = ref([]);
    const patchRequestList = ref([]);
    const patchGuidesCodes = ref([]);
    const deliveryStatusCodes = ref([]);
    const defaultDeliveryStatusCodes = ref([]);
    const saveDeliveryStatusCodes = ref([]);
    const fields = ["replyCn"];
    const totalInfo = ref(pactchHandler.getTotalInfo());
    const originTotalInfo = ref(null);
    const vulnVersionRange = ref(pactchHandler.createDefaultVulnVersionRange());
    const patchVersionMap = ref(pactchHandler.createDefaultPatchVersionMap());
    const hasPatchUpdatable = ref(false);
    const childRef = ref(null);

    // methods 정의
    const changeTab = (nextIndex) => {
      selectedTab.value = nextIndex;
    };
    const initCode = async () => {
      getPatchGuides();
      await getDeliveryStatus();
    };

    const getPatchGuides = () => {
      // 패치 안내방법 조회

      axios
        .post("/patch/pr/code/guide-type/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            patchGuidesCodes.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const getDeliveryStatus = async () => {
      // 납품 현황 목록 조회

      axios
        .post("/patch/pr/code/delivery-stat/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            defaultDeliveryStatusCodes.value = res.data.resList;
            if (!detailMod.value) {
              deliveryStatusCodes.value = buildDeliveryStatusList(
                defaultDeliveryStatusCodes.value
              );
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const buildDeliveryStatusList = (codes, deliveryStatus = []) => {
      const deliveryStatusMap = new Map(
        deliveryStatus.map((item) => [item.deliveryCode, item.deliveryCnt])
      );

      return codes.map((item) => ({
        cd: item.cd,
        cdNm: item.cdNm,
        checked: deliveryStatusMap.has(item.cd),
        count: deliveryStatusMap.get(item.cd) || 0,
      }));
    };

    const convertToDeliveryStatus = () => {
      return saveDeliveryStatusCodes.value
        .filter((status) => status.checked)
        .map((status) => ({
          deliveryCode: status.cd,
          deliveryCnt: status.count,
        }));
    };

    const updatePatchVersionMap = (data) => {
      if (!Array.isArray(data)) return [];
      return data.filter(
        (v) => v.vulnVersion || v.patchedVersion || v.fileHash
      );
    };
    const updateVulnVersionRange = (data) => {
      if (!Array.isArray(data)) return [];
      return data.filter((item) => {
        return dc.nullChk(item.minVersion) || dc.nullChk(item.maxVersion);
      });
    };

    const handleDeliveryStatusCodes = (val) => {
      saveDeliveryStatusCodes.value = val;
    };

    const addPatch = async () => {
      // 패치 접수
      if (!validatePatchData()) {
        return;
      }
      if (!confirm("패치 접수를 진행하시겠습니까? ")) {
        return;
      }

      const replyInfo = totalInfo.value.replyInfo;
      // url 이미지 저장 처리
      let res = await editor.handleEditorImages(replyInfo, fields, "patch");
      if (!res) {
        return;
      }

      // UI 데이터를 서버 전송용 데이터 형식으로 변환
      replyInfo.deliveryStatus = convertToDeliveryStatus();

      const dataInfo = {
        ...totalInfo.value.submitInfo,
        replyInfo: prepareReplyInfo(replyInfo),
        patchCvssEval: totalInfo.value.cvssEval,
      };

      const formData = new FormData();
      // 파일이 있다면 추가
      if (totalInfo.value.uploadFile) {
        formData.append("files", totalInfo.value.uploadFile);
      }
      if (totalInfo.value.actionGuideFiles) {
        formData.append("guideFiles", totalInfo.value.actionGuideFiles);
      }
      formData.append("data", JSON.stringify(dataInfo));
      showLoading();
      axios
        .post("/patch/pr/submission/add", formData)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("패치 접수를 등록하였습니다. 페이지를 새로고침합니다.");
            deleteAllIndexedDBs();
            router.go(0);
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const openReasonModal = () => {
      isModal.value = true;
    };

    const closeReasonModal = () => {
      isModal.value = false;
    };

    const prepareReplyInfo = (replyInfo) => {
      // UI 데이터를 서버 전송용 데이터 형식으로 변환
      replyInfo.deliveryStatus = convertToDeliveryStatus();

      // patchVersionMap가 비어있거나 모든 필드가 비어있는 항목은 필터링
      const filteredVulnVersionRange = !replyInfo.hasHomePage
        ? updateVulnVersionRange(replyInfo.vulnVersionRange)
        : [];

      const filteredPatchVersionMap =
        !replyInfo.hasHomePage && filteredVulnVersionRange.length > 0
          ? updatePatchVersionMap(replyInfo.patchVersionMap)
          : [];

      replyInfo.homePageUrl = replyInfo.hasHomePage
        ? replyInfo.homePageUrl
        : null;

      const finalReplyInfo = {
        ...replyInfo,
        patchVersionMap: filteredPatchVersionMap,
        vulnVersionRange: filteredVulnVersionRange,
      };

      return finalReplyInfo;
    };

    const applySelectionReason = async (reason) => {
      closeReasonModal();

      if (!confirm("패치 수정을 진행하시겠습니까? ")) {
        return;
      }

      // url 이미지 저장 처리
      const replyInfo = totalInfo.value.replyInfo;
      // url 이미지 저장 처리
      let res = await editor.handleEditorImages(replyInfo, fields, "patch");
      if (!res) {
        return;
      }

      const patchRegInfo = {
        id: route.query.id,
        kve: totalInfo.value.submitInfo.submitRequestInfos[0].kve,
        swNm: replyInfo.swNm,
        patchInfo: prepareReplyInfo(replyInfo),
        gubun: replyInfo.submitType,
      };

      const dataToUpdate = {
        reasonCode: reason.reasonCode,
        description: reason.description,
        patchRegInfo: patchRegInfo,
        patchCvssEval: totalInfo.value.cvssEval,
      };
      const formData = new FormData();
      // 파일이 있다면 추가
      if (totalInfo.value.uploadFile) {
        formData.append("files", totalInfo.value.uploadFile);
      }
      if (totalInfo.value.actionGuideFiles) {
        formData.append("guideFiles", totalInfo.value.actionGuideFiles);
      }
      formData.append("data", JSON.stringify(dataToUpdate));
      showLoading();
      axios
        .post("/patch/pr/records/set", formData)
        .then((res) => {
          closeReasonModal();

          if (res.data.resType === "RES_OK") {
            alert("패치 수정을 완료했습니다.");
            deleteAllIndexedDBs();

            edit.value = false;
            getPatchItem(route.query.id);
            changeTab(0);
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const updatePatch = () => {
      if (!validatePatchData()) {
        return;
      }

      openReasonModal();
    };

    const validatePatchData = () => {
      // 유효성 검사 (Validation)
      if (totalInfo.value.submitInfo.submitRequestInfos.length <= 0) {
        alert("KVE를 선택해주세요.");
        return false;
      }
      const replyInfo = totalInfo.value.replyInfo;

      if (!replyInfo.hasActionOk) {
        if (!dc.nullChk(replyInfo.replyCn)) {
          alert("조치 불가능 사유를 입력해주세요.");
          return false;
        }
      } else {
        const submitType = replyInfo.submitType;
        if (!dc.nullChk(replyInfo.devCompDate)) {
          if (submitType === "P") {
            alert("패치 개발 계획 일자를 선택해주세요.");
          } else {
            alert("패치 개발 일자를 선택해주세요.");
          }

          return false;
        }
        if (!dc.nullChk(replyInfo.deployDate)) {
          if (submitType === "P") {
            alert("패치 배포 계획 일자를 선택해주세요.");
          } else {
            alert("패치 배포 일자를 선택해주세요.");
          }
          return false;
        }

        if (!dc.nullChk(replyInfo.replyCn)) {
          if (submitType === "P") {
            alert("조치 계획 내용을 입력해주세요.");
          } else {
            alert("조치 결과 내용을 입력해주세요.");
          }
          return false;
        }

        if (saveDeliveryStatusCodes.value.length == 0) {
          saveDeliveryStatusCodes.value = deliveryStatusCodes.value;
        }

        const checkedDelivery = saveDeliveryStatusCodes.value.filter(
          (s) => s.checked
        );
        if (checkedDelivery.length === 0) {
          alert("납품 현황을 최소 1개는 선택해주세요.");
          return false;
        }

        if (!dc.nullChk(replyInfo.swNm)) {
          alert("제품 이름을 입력해주세요.");
          return false;
        }
        if (!dc.nullChk(replyInfo.swNm)) {
          alert("제품 이름을 입력해주세요.");
          return false;
        }

        if (replyInfo.hasHomePage) {
          if (!dc.nullChk(replyInfo.homePageUrl)) {
            alert("홈페이지 여부가 '네' 인 경우 홈페이지 주소를 입력해 주세요");
            return false;
          }
        } else {
          if (replyInfo.hasNoVulnVer) {
            if (!dc.nullChk(replyInfo.noVulnVerReason)) {
              alert(
                "취약한 버전 범위가 존재하지 않는 경우 사유를 입력해 주세요."
              );
              return false;
            }
          } else {
            if (
              !dc.nullChk(replyInfo.vulnVersionRange) ||
              replyInfo.vulnVersionRange.length === 0
            ) {
              alert(
                "홈페이지 여부가 '아니오' 인 경우 취약한 버전 범위를 입력해 주세요."
              );
              return false;
            }

            for (const version of replyInfo.vulnVersionRange) {
              if (
                !dc.nullChk(version.minVersion) ||
                !dc.nullChk(version.maxVersion)
              ) {
                alert("취약한 버전 범위를 모두 입력해 주세요.");
                return false;
              }
            }
            if (
              !dc.nullChk(replyInfo.patchVersionMap) ||
              replyInfo.patchVersionMap.length === 0
            ) {
              alert(
                "취약한 버전 범위 내 최소 1개 이상 취약한 버전/해결된 버전/파일 해시 정보를 입력해 주세요."
              );
              return false;
            }
            for (const version of replyInfo.patchVersionMap) {
              if (
                !dc.nullChk(version.vulnVersion) ||
                !dc.nullChk(version.patchedVersion) ||
                !dc.nullChk(version.fileHash)
              ) {
                alert(
                  "취약한 버전/해결된 버전/파일 해시 정보를 모두 입력해 주세요."
                );
                return false;
              }
            }
          }
        }

        if (replyInfo?.bigo?.length > 100000) {
          alert("비고의 내용은 100000자 이내로 입력해주세요.");
          return false;
        }
      }

      if (!dc.nullChk(replyInfo.hasCveIdAgree)) {
        alert(
          "CVE ID 발급 및 공개관련 안내에서 동의 또는 동의 안함을 선택해주세요."
        );
        return false;
      }
      const message =
        "완성되지 않은 CVSS 계산 정보가 존재합니다\n이대로 접수진행을 계속 하시겠습니까?";
      if (!confirmCvssIncomplete(message, totalInfo.value)) {
        return false;
      }

      return true;
    };
    // cvss계산 확인
    const confirmCvssIncomplete = (message, item) => {
      const evl = item?.cvssEval;
      if (item === null || evl === null) {
        return true;
      }

      if (evl?.evlItem?.cmptYn && !confirm(message)) {
        return false;
      }
      if (!dc.nullChk(evl.cvss) || evl.cvss === 0) {
        item.cvssEval = null;
      }

      return true;
    };

    const getPatchItem = (id) => {
      showLoading();

      axios
        .post(`/patch/pr/records/get/${id}`)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const resData = res.data.resList[0];
            hasPatchUpdatable.value = resData.hasPatchUpdatable;
            Object.assign(totalInfo.value.replyInfo, resData?.replyInfo);
            totalInfo.value.replyInfo.id = id;

            if (totalInfo.value.replyInfo === null) {
              alert("조회된 패치 정보가 없습니다. 이전 페이지로 이동합니다.");
              router.go(-1);
            }
            const cvssEval = dc.nullChk(resData.patchCvssEval)
              ? resData.patchCvssEval
              : pactchHandler.createDefaultEvalInfo();

            if (dc.nullChk(totalInfo.value.cvssEval) && dc.nullChk(cvssEval)) {
              Object.assign(totalInfo.value.cvssEval, cvssEval);
            }
            const tmp = {
              submitRequestInfos: resData.submitRequestInfos,
              hasPatchUpdatable: resData.hasPatchUpdatable,
            };
            totalInfo.value.submitInfo = tmp;

            originTotalInfo.value = {
              replyInfo: lodash.cloneDeep(totalInfo.value.replyInfo),
              cvssEval: lodash.cloneDeep(totalInfo.value.cvssEval),
            };

            deliveryStatusCodes.value = buildDeliveryStatusList(
              defaultDeliveryStatusCodes.value,
              totalInfo.value.replyInfo.deliveryStatus
            );

            if (!dc.nullChk(totalInfo.value.replyInfo.vulnVersionRange)) {
              totalInfo.value.replyInfo.vulnVersionRange = [
                vulnVersionRange.value,
              ];
            }
            if (!dc.nullChk(totalInfo.value.replyInfo.patchVersionMap)) {
              totalInfo.value.replyInfo.patchVersionMap = [
                patchVersionMap.value,
              ];
            }
            componentKey.value++;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const changeMod = (mode) => {
      let replyChange = false;
      let evalChange = false;

      if (!mode) {
        replyChange = dc.isChanged(
          originTotalInfo.value.replyInfo,
          totalInfo.value.replyInfo
        );
        evalChange = dc.isChanged(
          originTotalInfo.value.cvssEval,
          totalInfo.value.cvssEval
        );
      }

      if (replyChange || evalChange) {
        if (confirm("변경 사항이 있습니다. 저장 하시겠습니까?")) {
          isModal.value = true;
          return;
        } else {
          totalInfo.value.replyInfo = lodash.cloneDeep(
            originTotalInfo.value.replyInfo
          );

          totalInfo.value.cvssEval = lodash.cloneDeep(
            originTotalInfo.value.cvssEval
          );

          replyChange = false;
          evalChange = false;

          componentKey.value++;
        }
      }

      edit.value = mode;
    };

    // watch, computed 정의
    const tabComponents = computed(() => [Submission, VulEval]);

    // life cycle 정의
    onMounted(async () => {
      initCode();
      if (route.query.id) {
        detailMod.value = true;
        edit.value = false;
        getPatchItem(route.query.id);
        pageTitle.value = "취약점 패치 관리";
      }
      //   } else {
      //     const wasReload = sessionStorage.getItem("wasReload");

      //     if (!wasReload) {
      //       await nextTick();
      //       childRef.value[0].handleLoadFromIndexedDB();
      //     }
      //   }

      //   sessionStorage.removeItem("wasReload");
    });

    // html에서 사용될 데이터 정의
    return {
      edit,
      childRef,
      detailMod,
      changeMod,
      isModal,
      updatePatch,
      applySelectionReason,
      userInfo,
      totalInfo,
      selectedTab,
      tabComponents,
      changeTab,
      patchRegInfo,
      patchRequestList,
      patchGuidesCodes,
      deliveryStatusCodes,
      validatePatchData,
      addPatch,
      closeReasonModal,
      componentKey,
      pageTitle,
      hasPatchUpdatable,
      handleDeliveryStatusCodes,
    };
  },
};
</script>
